 import type { Apartment } from '@pigello/pigello-matrix';


import { useGetInstance, useGetList } from '@/requests/hooks';

import type {
  useGetGenericInstanceProps,
  useGetGenericListProps,
} from '@/requests/types';


export const useGetApartment = (
  options: useGetGenericInstanceProps<Apartment>
) => {
  return useGetInstance<Apartment>({
    ...options,
    modelName: 'apartment'
  });
};

export const useGetApartmentList = (
  options: useGetGenericListProps<Apartment>
) => {
  return useGetList<Apartment>({
    ...options,
    modelName: 'apartment'
  });
};
